/**
 * Severity Tag Component
 * Auto-colored severity badges (Critical, High, Medium, Low)
 */

import React from 'react';
import { Tag } from 'antd';
import {
  FireOutlined,
  WarningOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { getSeverityTagProps } from '../../theme/componentVariants';

/**
 * Severity Tag with auto-coloring
 *
 * @param {string} severity - Severity level (critical, high, medium, low)
 * @param {boolean} showIcon - Show severity icon (default: true)
 * @param {boolean} uppercase - Uppercase text (default: true)
 * @param {object} style - Additional styles
 */
function SeverityTag({ severity, showIcon = true, uppercase = true, style = {}, ...props }) {
  if (!severity) return null;

  const severityProps = getSeverityTagProps(severity);
  const text = uppercase ? String(severity).toUpperCase() : String(severity);

  // Map icons to severity
  const getIcon = () => {
    if (!showIcon) return null;

    const severityLower = String(severity).toLowerCase();

    switch (severityLower) {
      case 'critical':
        return <FireOutlined />;
      case 'high':
        return <WarningOutlined />;
      case 'medium':
        return <InfoCircleOutlined />;
      case 'low':
        return <CheckCircleOutlined />;
      default:
        return null;
    }
  };

  return (
    <Tag
      icon={getIcon()}
      style={{
        ...severityProps.style,
        ...style,
      }}
      {...props}
    >
      {text}
    </Tag>
  );
}

export default SeverityTag;
